import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.488 6.981H12.5v1.431c4.171.26 7.488 3.726 7.488 7.962v3.641H4.012v-3.641c0-4.235 3.317-7.702 7.488-7.962V6.981H5.512c-.827 0-1.5-.673-1.5-1.5V4h1v1.481a.5.5 0 0 0 .5.5h12.976a.5.5 0 0 0 .5-.5V4.022h1v1.459c0 .827-.673 1.5-1.5 1.5zm.5 9.394A6.996 6.996 0 0 0 12 9.387a6.996 6.996 0 0 0-6.988 6.988v2.641h13.976v-2.641zM12 16.917a.75.75 0 0 1-.75-.75v-3.542a.75.75 0 0 1 1.5 0v3.542a.75.75 0 0 1-.75.75z"
});

var SvgWeight = function SvgWeight(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgWeight;